import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { TextField, Alert, Button, Stack, BaseDialog, DialogActions } from '@metarouter-private/mr-mui';
import { useUpdateWebhookConfig } from '@ion/api';
import isValidWebhookUrl from 'app/settings/webhook-settings-page/isValidWebhookUrl';

export default function EditUrlModal({ onClose, webhookConfig }) {
  const [url, setUrl] = useState(webhookConfig.url ?? '');
  const [urlTouched, setUrlTouched] = useState(false);
  const [error, setError] = useState(null);

  const isUrlValid = isValidWebhookUrl(url);
  const urlError = urlTouched && Boolean(url.trim()) && !isUrlValid;

  const [updateConfig, { loading }] = useUpdateWebhookConfig({
    onCompleted: () => onClose(),
    onError: err => setError(err.message),
  });

  const handleSubmit = () => {
    setError(null);
    if (!isUrlValid) {
      setError('Please enter a valid URL (e.g. https://example.com/webhook)');
      return;
    }
    updateConfig({ webhookConfigId: webhookConfig.id, url: url.trim() });
  };

  return (
    <BaseDialog
      DialogProps={{ open: true, onClose, fullWidth: true }}
      title="Edit Webhook URL"
      content={
        <Stack spacing={2}>
          {error && <Alert severity="error">{error}</Alert>}
          <TextField
            label="Webhook URL"
            value={url}
            onChange={event => setUrl(event.target.value)}
            onBlur={() => setUrlTouched(true)}
            helperText={urlError ? 'Please enter a valid URL (e.g. https://example.com/webhook)' : null}
            error={urlError}
            fullWidth
          />
        </Stack>
      }
      actions={
        <DialogActions>
          <Button variant="outlined" color="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="contained" onClick={handleSubmit} disabled={loading || !url.trim()}>
            {loading ? 'Saving...' : 'Save'}
          </Button>
        </DialogActions>
      }
    />
  );
}

EditUrlModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  webhookConfig: PropTypes.shape({
    id: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
};
